<template>
  <Bar :chart-data="chartData" :chart-options="chartOptions" :styles="styles"/>
</template>

<script>
import { Bar } from 'vue-chartjs'

export default {
      components: {
            Bar
      },
      props: {
            chartdata: {
                  type: Object,
                  default: null
            },
            options: {
                  type: Object,
                  default: null
            },
            styles: {
                  type: Object,
                  default: () => {}
            }
      },
      data() {
            return {
                  chartData: this.chartdata,
                  chartOptions: structuredClone(this.options)
            }
      }
}
</script>